import React, { useMemo } from 'react';
import AppDimensionsContext from './useAppDimensions.context';

function AppDimensionsProvider({
  children,
  width,
  height,
  isMobile,
}: React.PropsWithChildren<{
  width: number;
  height: number;
  isMobile: boolean;
}>) {
  const state = useMemo(() => ({
    height,
    isMobile,
    width,
  }), [width, height, isMobile]);

  return (
    <AppDimensionsContext.Provider
      value={state}
    >
      {children}
    </AppDimensionsContext.Provider>
  );
}
export default AppDimensionsProvider;
